import React from 'react';
import { CustomHeader } from '../../components/CustomHeaderComponent/customHeader';
import {
  AlertsLevelComponent,
  AlertsLevelFraudComponent,
  RevertComponent,
  TextComponent
} from '../../components/TableComponents';
import { getStrForChampion } from '../../trmUtil';
import { PromoteComponent } from '../../components/TableComponents/PromoteComponent';
import { convertISOToDateFormat } from '../../../../util/timezone';
import { toLower } from '../../../../util/lodashlike';

// FIN-12133: build the per-row Action colour resolver — the action's configured
// severity (action_severity) mapped to its level colour from alert_level_details.
const makeActionColor = (typologyActionList, getLevelColor) => (action) =>
  getLevelColor?.(
    typologyActionList?.find(
      ({ displayName }) => toLower(displayName) === toLower(action)
    )?.actionSeverity
  );

export const getChampionColumns = (isFraudPrevention, getLevelColor) => [
  {
    title: <CustomHeader title={'ID'} />,
    key: 'champion',
    render: ({ challengerId }) => (
      <TextComponent style={{ color: '#0C8ED7' }} id={challengerId} />
    )
  },
  {
    title: <CustomHeader title={'Creator'} />,
    key: 'champion',
    width: '20%',
    render: ({ creator }) => (
      <TextComponent style={{ color: '#0C8ED7' }} id={creator} />
    )
  },
  {
    title: <CustomHeader title={'Create Date'} />,
    key: 'champion',
    width: '20%',
    render: ({ createdDate }) => (
      <TextComponent id={convertISOToDateFormat(createdDate)} />
    )
  },
  {
    title: <CustomHeader title={'Alert Count'} />,
    key: 'champion',
    render: ({ totalAlert }) => <TextComponent id={totalAlert} />
  },
  {
    title: <CustomHeader title={'Alert Level/Actions Count'} />,
    width: '30%',
    key: 'champion',
    render: (champion) => {
      const {
        alertLevelConfiguration = [],
        actionCount = {},
        typologyActionList = {}
      } = champion;

      if (isFraudPrevention) {
        return (
          <AlertsLevelFraudComponent
            actionCount={actionCount}
            actionList={typologyActionList}
            getActionColor={makeActionColor(typologyActionList, getLevelColor)}
          />
        );
      } else {
        return (
          <AlertsLevelComponent alertLevelConfig={alertLevelConfiguration} />
        );
      }
    }
  },
  {
    title: <CustomHeader title={'Str'} />,
    key: 'champion',
    render: ({ str }) => <TextComponent id={getStrForChampion(str)} />
  }
];

export const getPreviousChampionsColumns = (
  authentication,
  isFraudPrevention,
  onRevertCurrentChampion,
  getLevelColor
) => [
  ...getChampionColumns(isFraudPrevention, getLevelColor),
  {
    title: <CustomHeader title={'Action'} />,
    width: '10%',
    key: 'champion',
    align: 'center',
    render: (champion) => (
      <RevertComponent
        champion={champion}
        onAction={onRevertCurrentChampion}
        authentication={authentication}
      />
    )
  }
];

export const getPreviousChallengersColumns = (
  authentication,
  isFraudPrevention,
  onPromoteChallenger,
  getLevelColor
) => [
  ...getChampionColumns(isFraudPrevention, getLevelColor),
  {
    title: <CustomHeader title={'Action'} />,
    width: '10%',
    key: 'champion',
    align: 'center',
    render: (champion) => (
      <PromoteComponent
        champion={champion}
        onAction={onPromoteChallenger}
        authentication={authentication}
      />
    )
  }
];
